import { motion } from "framer-motion";

export const NineDotMark = ({ size = 1, className = "", animate = true }) => (
    <motion.img
        src="/logo.jpg"
        alt="Clear D 9-dot logo"
        className={`select-none ${className}`}
        style={{ width: `${96 * size}px`, height: `${96 * size}px` }}
        draggable={false}
        initial={animate ? { scale: 0.6, opacity: 0, rotate: -8 } : false}
        animate={animate ? { scale: 1, opacity: 1, rotate: 0 } : false}
        transition={{ type: "spring", stiffness: 220, damping: 16, delay: 0.08 }}
    />
);

export const HeaderMark = ({ size = 1 }) => (
    <img
        src="/logo.jpg"
        alt="Clear D logo"
        className="select-none rounded-[3px]"
        style={{ width: `${22 * size}px`, height: `${22 * size}px` }}
        draggable={false}
    />
);
